import React, { useEffect, useMemo, useState } from 'react';
import { Col, Form } from 'antd';
import AppLoader from '@sharedComponent/app-loader';
import Input from 'src/pages/userComponents/text-field/index';
import StepButton from '@pages/userComponents/Step-Button/StepButton';
import TextComponent from '@sharedComponent/typography/TextComponent';
import { useHistory } from 'react-router-dom';
import useScreenSize from 'use-screen-size';
import 'antd/dist/antd.css';
import 'src/pages/userComponents/userStyle.scss';

const CompanyInfoPresentational = ({
	companyInfoData,
	isCompanyLoading,
	setCompanyInfoStart,
	savingCompanyInfoData,
	savingStatus,
	setCompanyInfoReset,
}) => {
	const history = useHistory();
	const size = useScreenSize();
	const [nameOfLicense, setnameOfLicense] = useState('');
	const [vatNumber, setvatNumber] = useState('');
	const [noPayrollCard, setpayrollCardNumber] = useState('');
	const [empWithBankAcnt, setempWithBankAcnt] = useState('');
	const [officeAddress, setofficeAddress] = useState('');
	const [poAddress, setpoAddress] = useState('');
	const [errorMsgList, setErrorMsgList] = useState({
		nameOfLicenseerr: '',
		vatNumbererr: '',
		payrollCardNumbererr: '',
		empWithBankAcnterr: '',
		officeAddresserr: '',
		poAddresserr: '',
	});

	// block special char in string
	//event.target.value.replace(/[^\w\s]/gi, "")
	const blockSpecialChar = (string = '') => {
		return string && string?.replace(/[^\w\s]/gi, '');
	};

	const inputHandler = (e) => {
		if (/[^\w\s]/gi.test(e.key)) {
			e.preventDefault();
		}
	};

	useEffect(() => {
		if (companyInfoData && companyInfoData) {
			setnameOfLicense(companyInfoData.mainTradeLicenseName);
			setvatNumber(companyInfoData.vatTrnNumber);
			setpayrollCardNumber(companyInfoData.numberOfPayrollCards);
			setempWithBankAcnt(companyInfoData.numberOfBankAccounts);
			setofficeAddress(companyInfoData.address);
			setpoAddress(companyInfoData.poBox);
		}
	}, [companyInfoData]);

	useEffect(() => {
		if (savingStatus) {
			setCompanyInfoReset();
			history.push({
				pathname: `/user/contactinfo/1`,
				state: {
					companyId: companyInfoData.companyId,
				},
			});
		}
	}, [savingStatus]);

	const onFinish = (val) => {
		if (nameOfLicense && noPayrollCard && officeAddress && poAddress && vatNumber) {
			setCompanyInfoStart(
				{
					mainTradeLicenseName: nameOfLicense,
					vatTrnNumber: vatNumber,
					numberOfPayrollCards: noPayrollCard,
					numberOfBankAccounts: parseInt(empWithBankAcnt),
					address: officeAddress,
					poBox: poAddress,
				},
				companyInfoData.companyId
			);
		}
	};

	const validateForm = (e) => {
		if (e.target.name == 'nameOfLicense') {
			if (nameOfLicense && nameOfLicense.length == 0) {
				setErrorMsgList((prevState) => {
					return { ...prevState, nameOfLicenseerr: 'Enter the name of your company as mentioned on the trade license' };
				});
			} else {
				setErrorMsgList((prevState) => {
					return { ...prevState, nameOfLicenseerr: '' };
				});
			}
		}
		if (e.target.name == 'vatNumber') {
			if (vatNumber && vatNumber.length == 0) {
				setErrorMsgList((prevState) => {
					return { ...prevState, vatNumbereerr: 'VAT TRN Number is mandatory' };
				});
			} else {
				setErrorMsgList((prevState) => {
					return { ...prevState, vatNumbereerr: '' };
				});
			}
		}
		if (e.target.name == 'noPayrollCard') {
			if (noPayrollCard && noPayrollCard.length == 0) {
				setErrorMsgList((prevState) => {
					return { ...prevState, payrollCardNumbererr: 'How many unbanked employees do you have?' };
				});
			} else {
				setErrorMsgList((prevState) => {
					return { ...prevState, payrollCardNumbererr: '' };
				});
			}
		}
		if (e.target.name == 'noBankAccount') {
		}
		if (e.target.name == 'ofcAddress') {
			if (officeAddress && officeAddress.length == 0) {
				setErrorMsgList((prevState) => {
					return { ...prevState, officeAddresserr: 'Enter your Area followed by your Emirate' };
				});
			} else {
				setErrorMsgList((prevState) => {
					return { ...prevState, officeAddresserr: '' };
				});
			}
		}
		if (e.target.name == 'poBox') {
			if (poAddress && poAddress.length == 0) {
				setErrorMsgList((prevState) => {
					return { ...prevState, poAddresserr: 'PoBox must not be empty' };
				});
			} else {
				setErrorMsgList((prevState) => {
					return { ...prevState, poAddresserr: '' };
				});
			}
		}
	};
	const isValid = useMemo(
		() => !!(nameOfLicense && noPayrollCard && officeAddress && poAddress && vatNumber),
		[nameOfLicense, noPayrollCard, officeAddress, poAddress, vatNumber]
	);

	return (
		<div>
			<Col>
				{isCompanyLoading ? (
					<AppLoader />
				) : (
					<Form
						onFinish={onFinish}
						initialValues={{
							nameOfLicense: companyInfoData && companyInfoData.mainTradeLicenseName,
							noBankAccount: companyInfoData && companyInfoData.numberOfBankAccounts,
							noPayrollCard: companyInfoData && companyInfoData.numberOfPayrollCards.toString(),
							ofcAddress: companyInfoData && companyInfoData.address,
							poBox: companyInfoData && companyInfoData.poBox,
							vatNumber: companyInfoData && companyInfoData.vatTrnNumber,
						}}>
						<Form.Item
							type="text"
							name="nameOfLicense"
							validateTrigger="onBlur"
							rules={[
								{
									required: true,
									message: 'Enter the name of your company as mentioned on the trade license',
								},
							]}>
							<Input
								//value={'nameOfLicense'}
								labels={
									<span>
										Name on Main Trade License <text style={{ color: 'red' }}>*</text>
									</span>
								}
								onChange={(e) => setnameOfLicense(blockSpecialChar(e.target.value))}
								onKeyDown={(e) => inputHandler(e)}
							/>
						</Form.Item>
						<Form.Item
							name="vatNumber"
							validateTrigger="onBlur"
							rules={[
								{
									required: true,
									message: 'VAT TRN Number is mandatory',
								},
							]}>
							<Input
								type="text"
								labels={
									<span>
										VAT TRN Number <text style={{ color: 'red' }}>*</text>
									</span>
								}
								onBlur={validateForm}
								maxLength="100"
								onChange={(e) => setvatNumber(e.target.value.replace(/[^0-9]/g, ''))}
							/>
						</Form.Item>
						<Form.Item
							rules={[
								{
									required: true,
									pattern: '^((?:[1-9][0-9]*)(?:.[0-9]+)?)$',
									message: 'You must have a minimum of 1 payroll card',
								},
							]}
							name="noPayrollCard"
							validateTrigger="onBlur">
							<Input
								onBlur={validateForm}
								labels={
									<span>
										Number of Payroll Cards <text style={{ color: 'red' }}>*</text>
									</span>
								}
								maxLength="100"
								onChange={(e) => setpayrollCardNumber(parseInt(e.target.value.replace(/[^0-9]/g, '')))}
							/>
						</Form.Item>
						<Form.Item name="noBankAccount">
							<Input
								name="noBankAccount"
								type="text"
								maxLength="100"
								onBlur={validateForm}
								labels={size.width < 500 ? 'No. of Employees with Bank Accounts' : 'Number of Employees with Bank Accounts'}
								onChange={(e) => setempWithBankAcnt(e.target.value.replace(/[^0-9]/g, ''))}
							/>
						</Form.Item>
						<div className="comInfoText">
							<Form.Item>
								<TextComponent className="text1">
									<p>This refers to your employees who already have existing bank accounts and do not require payroll cards.</p>
								</TextComponent>
							</Form.Item>
						</div>
						<Form.Item
							style={{ marginTop: '15px' }}
							name="ofcAddress"
							rules={[{ required: true, message: 'Enter your Area followed by your Emirate' }]}
							validateTrigger="onBlur">
							<Input
								type="text"
								labels={
									<span>
										Office Address <text style={{ color: 'red' }}>*</text>
									</span>
								}
								name="ofcAddress"
								onBlur={validateForm}
								maxLength="100"
								onChange={(e) => setofficeAddress(e.target.value)}
							/>
						</Form.Item>
						<Form.Item>
							<TextComponent className="text1">
								<p>This can be different from your card delivery address.</p>
							</TextComponent>
						</Form.Item>
						<Form.Item name="poBox" rules={[{ required: true, message: 'PoBox must not be empty' }]} validateTrigger="onBlur">
							<Input
								type="text"
								labels={
									<span>
										P.O. Box <text style={{ color: 'red' }}>*</text>
									</span>
								}
								name="poBox"
								value={poAddress}
								onBlur={validateForm}
								onChange={(e) => setpoAddress(e.target.value.replace(/[^0-9]/g, ''))}
								maxLength="8"
							/>
						</Form.Item>
						<Form.Item>
							<StepButton disabled={!isValid} buttonText={'Next'} loading={savingCompanyInfoData} />
						</Form.Item>
					</Form>
				)}
			</Col>
		</div>
	);
};
export default CompanyInfoPresentational;
